/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ToolbarDockAPI
 * @hideconstructor
 * @classdesc API class that is used to manage the DOM of Toolbar Dock.
 */
define([], () => {
	class ToolbarDockDOMAPI{
		/**
		 * @function ToolbarDockDOMAPI#render
		 * @description render the UI on DOM
		 */
		render(){}

		/**
		 * @function ToolbarDockDOMAPI#addProvider
		 * @description an interface which allows others to contribute to the ToolbarDockDOM
		 * @param {String} providerID the id of a provider
		 * @param {Object} provider the provider which will contribute a part of UI of the ToolbarDockDOM
		 */
		addProvider(/**providerID, provider */){}

		/**
		 * @function ToolbarDockDOMAPI#removeProvider
		 * @description remove a provider from this feature
		 * @param {String} providerID the id of a provider which will be removed
		 */
		removeProvider(){}

		/**
		 * @function ToolbarDockDOMAPI#getProviders
		 * @description get all providers of this feature
		 * @return {Object} an object whose keys are provider IDs and values are providers
		 */
		getProviders(){}
	}

	return ToolbarDockDOMAPI;
});
